var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating"},_vm._l(([1, 2, 3, 4, 5]),function(count){
var _obj;
return _c('dotcom-icon',{key:count,staticClass:"rating__icon",class:( _obj = {}, _obj['rating__icon--active'] = count <= _vm.value, _obj ),attrs:{"art":"solid","name":"star"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }